import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/form/index.js
// module id = 749
// module chunks = 0